import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  [
    <circle key='0' fill='#d32f2f' cx='12' cy='12' r='12' />,
    <path
      key='1'
      fill='#FFFFFF'
      d='M7.7,4.6c-0.3-0.3-0.8-0.3-1.2,0c-1.4,1.3-2.4,3.1-2.7,5c-0.1,0.5,0.3,1,0.8,1c0.4,0,0.7-0.3,0.8-0.7
	c0.3-1.7,1.1-3.1,2.3-4.1C8,5.4,8,4.9,7.7,4.6z'
    />,
    <path key='2' fill='#FFFFFF' d='M12,20.1c0.9,0,1.7-0.7,1.7-1.7h-3.3C10.3,19.3,11.1,20.1,12,20.1z' />,
    <path
      key='3'
      fill='#FFFFFF'
      d='M17,15.1V11c0-2.5-1.4-4.7-3.7-5.2V5.2C13.3,4.5,12.7,4,12,4s-1.2,0.6-1.2,1.2v0.6C8.4,6.3,7,8.4,7,11v4.1
	l-1.1,1.1c-0.5,0.5-0.2,1.4,0.6,1.4h10.9c0.7,0,1.1-0.9,0.6-1.4L17,15.1z'
    />,
    <path
      key='4'
      fill='#FFFFFF'
      d='M17.5,4.6c-0.3-0.3-0.8-0.3-1.2,0c-0.3,0.3-0.3,0.9,0,1.2c1.1,1.1,2,2.5,2.2,4.1c0.1,0.4,0.4,0.7,0.8,0.7
	c0.5,0,0.9-0.5,0.8-1C19.9,7.6,18.9,5.9,17.5,4.6z'
    />,
  ],
  'TransportConditionAlarm'
);

const TransportConditionAlarmIcon = function (props) {
  return <SvgIcon {...props} />;
};

export default memo(TransportConditionAlarmIcon);
